import IconSizeEnum from '@models/enums/IconSizeEnum';
import useAriaLabels from '@utils/hooks/useAriaLabels';
import classNames from 'classnames';
import { MouseEventHandler } from 'react';

interface Props {
  readonly ariaLabel?: string;
  readonly className?: string;
  readonly color?: 'black' | 'white' | 'red';
  readonly onClick: MouseEventHandler;
  readonly size?: IconSizeEnum | string;
  readonly dataTestId?: string;
}

const CloseButton = ({
  ariaLabel,
  className,
  color = 'black',
  onClick,
  size = IconSizeEnum.lg,
  dataTestId,
}: Props) => {
  const { closeModalAriaLabel } = useAriaLabels();

  const closeColours = {
    black: 'before:bg-black-100 after:bg-black-100',
    white: 'before:bg-white after:bg-white',
    red: 'before:bg-red-100 after:bg-red-100',
  };

  return (
    <button
      type="button"
      className={classNames('close-button', closeColours[color], className)}
      aria-label={ariaLabel ?? closeModalAriaLabel}
      style={{ width: size, height: size }}
      onClick={onClick}
      data-testid={dataTestId}
    />
  );
};

export default CloseButton;
